import React, { Component } from "react";
import { connect } from 'react-redux';
import { setGemiAdı } from "../../actions/Actions";

class GemiAdiInput extends Component {
    render() {
        const { gemiAdı } = this.props;
        return (
            <input type="text" className="form-control" value={gemiAdı}
                onChange={e => this.props.setGemiAdı(e.target.value)} />
        );
    }
}

const mapStateToProps = state => ({
    gemiAdı: state.reducer.gemiAdı
});

const mapDispatchToProps = dispatch => ({
    setGemiAdı: (gemiAdı) => { setGemiAdı(dispatch, gemiAdı); }
});

export default connect(mapStateToProps, mapDispatchToProps)(GemiAdiInput);


// WEBPACK FOOTER //
// ./src/components/containers/GemiAdiInput.js